import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import {AppContext} from '../context/AppContext'
import {ReactComponent as VoltaIcon} from '../images/volta-app-icon.svg'

const BookTripIphone = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)
  const {tripDetails, prevPage, setPrevPage, nextPage, setNextPage, infoShow, setInfoShow} = useContext(AppContext)
  setInfoShow(true)

  return (
   <div id="iphone-screen" className="content">
    
      <img className="iphone-desktop" src="https://i.redd.it/7lnjrtx9agwz.jpg"></img>
      <Link to="confirmed" className="button volta-icon only-icon">
        <VoltaIcon/>
      </Link>  
    </div>
  )
}

export default BookTripIphone
